import {Component, forwardRef, HostBinding, HostListener, Input, OnInit} from '@angular/core';
import {ControlValueAccessor, NG_VALUE_ACCESSOR} from '@angular/forms';

@Component({
    selector: 'counter',
    template: `
        <ion-button class="ion-no-margin"
                    fill="clear"
                    expand="full">
            <ion-label color="black">{{label}}</ion-label>
        </ion-button>
    `,
    providers: [{
        provide: NG_VALUE_ACCESSOR,
        useExisting: forwardRef(() => CounterComponent),
        multi: true
    }],
    standalone: false
})
export class CounterComponent implements ControlValueAccessor, OnInit {
    @HostBinding('class') classes = 'ion-no-margin';

    public value: number;

    @Input()
    public label: string;

    @Input()
    public negative: boolean;

    constructor() {
    }

    ngOnInit(): void {

    }

    writeValue(value: number) {
        this.value = value;
    }

    propagateChange = (_: any) => {
    };
    propagateTouch = () => {
    };

    registerOnChange(fn) {
        this.propagateChange = fn;
    }

    registerOnTouched(fn) {
        this.propagateTouch = fn;
    }

    @HostListener('click', ['$event'])
    increment(event: any): void {
        if (this.negative) {
            this.value--;
        } else {
            this.value++;
        }

        this.propagateChange(this.value);
        this.propagateTouch();
    }
}
